import { render, staticRenderFns } from "./ProspectDocument.vue?vue&type=template&id=6196fe5c"
import script from "./ProspectDocument.vue?vue&type=script&lang=ts"
export * from "./ProspectDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports